export default __webpack_public_path__ + "static/media/skrill.13689006.svg";